import flagUs from "assets/images/flags/20/us.svg";
import flagarabic from "assets/images/flags/20/ae.svg";


const languages = {
  en: {
    label: "English",
    flag: flagUs,
  },
  ar: {
    label: "Arabic",
    flag: flagarabic,
  },
}

export default languages
